import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  num: '01',
  title: 'Diagnóstico estratégico',
  desc: 'Analizamos tu operación para identificar dónde está el caos y qué lo está generando.'
}, {
  num: '02',
  title: 'Diseño de estructura',
  desc: 'Definimos procesos, roles, decisiones y estructura operativa clara.'
}, {
  num: '03',
  title: 'Implementación con criterio',
  desc: 'Aplicamos estrategia, liderazgo y tecnología para que el negocio funcione mejor.'
}];
export function ProcessSection() {
  return <section className="py-24 px-6 bg-navy-dark" data-id="element-119">
      <div className="max-w-6xl mx-auto" data-id="element-120">
        <FadeIn data-id="element-121">
          <h2 className="text-3xl md:text-5xl font-serif text-center mb-20" data-id="element-122">
            Cómo trabajo contigo para{' '}
            <span className="text-gold" data-id="element-123">ordenar tu negocio</span>
          </h2>
        </FadeIn>

        <div className="relative mb-20" data-id="element-124">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-[1px] bg-gold/30 z-0" data-id="element-125"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6 relative z-10" data-id="element-126">
            {steps.map((step, i) => <FadeIn key={i} delay={i * 0.2} className="flex flex-col items-center text-center" data-id="element-127">
                <div className="w-24 h-24 rounded-full bg-navy border-2 border-gold flex items-center justify-center mb-8 shadow-[0_0_15px_rgba(201,168,76,0.2)]" data-id="element-128">
                  <span className="text-3xl font-serif font-bold text-gold" data-id="element-129">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-2xl font-serif text-white mb-4" data-id="element-130">
                  {step.title}
                </h3>
                <p className="text-gray-light text-lg max-w-xs" data-id="element-131">{step.desc}</p>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.6} data-id="element-132">
          <p className="text-center text-xl md:text-2xl font-serif text-white max-w-2xl mx-auto" data-id="element-133">
            El objetivo no es complicar tu negocio.{' '}
            <br className="hidden sm:block" data-id="element-134" />
            <span className="text-gold" data-id="element-135">
              Es que funcione con claridad y control.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}